import { render, staticRenderFns } from "./planificaciones.vue?vue&type=template&id=3a88a6d2"
import script from "./planificaciones.vue?vue&type=script&lang=js"
export * from "./planificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports